import { render, staticRenderFns } from "./Interest.vue?vue&type=template&id=7872bf6b&scoped=true&"
import script from "./Interest.vue?vue&type=script&lang=js&"
export * from "./Interest.vue?vue&type=script&lang=js&"
import style0 from "./Interest.vue?vue&type=style&index=0&id=7872bf6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7872bf6b",
  null
  
)

export default component.exports